import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Content, Sider } = Layout;

const graphs = [
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Evolución en el tiempo",
    text: `En 2024, un 26% de las niñas y los niños viven en barrios con una alta exposición a la contaminación acústica. Desde 2015, la proporción de niñas y niños en esta situación ha aumentado 
          en tres puntos porcentuales.`,
    link: "https://public.flourish.studio/visualisation/20877807/embed",
  },
  {
    id: "graph2",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `En ningún año de medición, hay diferencias entre la proporción de niñas y de niños que viven expuestos a contaminación acústica.`,
    link: "https://public.flourish.studio/visualisation/20877820/embed",
  },
  {
    id: "graph3",
    title: "Análisis por edad",
    menuTitle: "\u2022 Edad",
    text: `Históricamente, no se habían observado diferencias significativas en la exposición a contaminación acústica según el tramo etario en ningún año de medición hasta 2022. Sin embargo, los 
          datos de 2024 marcan un punto de inflexión: por primera vez, la Primera Infancia (27%) presenta niveles de exposición significativamente mayores que la Infancia Media (25%).

  Los efectos que tienen los ruidos molestos sobre niñas y niños varían de acuerdo a la etapa del ciclo vital en que se encuentran, por lo que las formas de mitigar esta problemática serán 
        diferentes y es necesario avanzar en estimar de forma más específica a qué cantidad de ruido están siendo expuestas niñas y niños.`,
    link: "https://public.flourish.studio/visualisation/20877852/embed",
  },
  {
    id: "graph4",
    title: "Análisis por país de nacimiento",
    menuTitle: "\u2022 País de nacimiento",
    text: `Si bien hasta la medición de 2022 no se registraban diferencias significativas entre niñas y niños nacidos en Chile y en otro país, la medición de 2024 revela, por primera vez, una brecha 
          estadística donde los niños nacidos en Chile (26%) presentan una mayor exposición que los nacidos en el extranjero (23%).`,
    link: "https://public.flourish.studio/visualisation/20877892/embed",
  },
  {
    id: "graph5",
    title: "Análisis por pueblo originario",
    menuTitle: "\u2022 Pueblo originario",
    text: `Hasta el año 2022 no se observan diferencias significativas en la exposición según pertenencia a pueblos originarios. No obstante, en 2024 se observa un cambio de tendencia: si bien 
          todavía no existe diferencia significativa entre ambos grupos, las niñas y niños que se identifican con pueblos originarios muestran por primera vez un promedio de exposición superior 
          (27%) al grupo que no se identifica (26%).`,
    link: "https://public.flourish.studio/visualisation/20878174/embed",
  },
  {
    id: "graph6",
    title: "Análisis por quintil de ingresos",
    menuTitle: "\u2022 Quintil de ingresos",
    text: `No existen diferencias estadísticamente significativas en la exposición a contaminación acústica según quintil de ingresos en ninguno de los años de la medición.`,
    link: "https://public.flourish.studio/visualisation/28030764/embed",
  },
  {
    id: "graph7",
    title: "Análisis por zona de residencia",
    menuTitle: "\u2022 Zona",
    text: `Las niñas y los niños que residen en zonas urbanas viven en mayor medida en entornos con contaminación acústica que aquellas y aquellos que residen en zonas rurales. En 2024, un 28% de 
          las niñas y los niños de zonas urbanas vivían en este escenario y un 11% de las niñas y los niños de zonas rurales. Esta brecha muestra que la contaminación acústica es un problema que 
          se tiende a concentrar en los conos urbanos.`,
    link: "https://public.flourish.studio/visualisation/20878151/embed",
  },
  {
    id: "graph8",
    title: "Análisis por región",
    menuTitle: "\u2022 Región",
    text: `En 2024, las regiones que tienen una mayor proporción de niñas y niños viviendo en barrios con una alta contaminación acústica son la región de Antofagasta (31%) y la región Metropolitana 
          (34%). Por otro lado, las que tienen una menor proporción son Los Ríos y La Araucanía, ambas con un 12%. El comportamiento de este indicador ha variado bastante desde 2015: el cambio más 
          notable está en Tarapacá, que bajó 6 puntos porcentuales en total desde la primera medición, y en Aysén, que tuvo una mejora importante entre 2022 y 2024, bajando su nivel de contaminación 
          acústica en 7 puntos porcentuales.`,
    link: "https://public.flourish.studio/visualisation/23232118/embed",
  },
];


const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;

